/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { PREFIX } from './index';

// --- Permits
export const FETCH_PERMIT = `${PREFIX}FETCH_PERMIT`;
export const RESET_PERMIT = `${PREFIX}RESET_PERMIT`;

// --- Permits
export const FETCH_PERMIT_TYPES = `${PREFIX}FETCH_PERMIT_TYPES`;
export const RESET_PERMIT_TYPES = `${PREFIX}RESET_PERMIT_TYPES`;

// --- Seasons
export const FETCH_SEASONS = `${PREFIX}FETCH_SEASONS`;
export const RESET_SEASONS = `${PREFIX}RESET_SEASONS`;

// --- Availability
export const FETCH_AVAILABILITY = `${PREFIX}FETCH_AVAILABILITY`;
export const RESET_AVAILABILITY = `${PREFIX}RESET_AVAILABILITY`;

// --- Reservations
export const ADD_RESERVATION = `${PREFIX}ADD_RESERVATION`;
export const UPDATE_RESERVATION = `${PREFIX}UPDATE_RESERVATION`;
export const FETCH_RESERVATION = `${PREFIX}FETCH_RESERVATION`;
export const RESET_RESERVATION = `${PREFIX}RESET_RESERVATION`;
export const FETCH_LOCATIONS = `${PREFIX}FETCH_LOCATIONS`;

// -- Validations
export const SET_VALIDATION_ERROR = `${PREFIX}SET_VALIDATION_ERROR`;
export const DISPLAY_UI_VALIDATIONS = `${PREFIX}DISPLAY_UI_VALIDATIONS`;

// -- Issuance
export const GET_ISSUANCE_PDF_ERROR = 'VP_GET_ISSUANCE_PDF_ERROR';
